import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function NavbarEmpty() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/');
        }
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        } else {
            navigate('/');
        }
    }, [navigate]);
    if (!user) {
        return <div>Loading...</div>;
    }
    return (
      <nav
        className="navbar navbar-expand-lg navbar-dark bg-success fixed-top"
        style={{
          background:
            'linear-gradient(135deg, rgb(19, 72, 156) 0%, rgba(19, 72, 156, 1) 100%)',
        }}
      >
        <div className="container-fluid">
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="65"
            height="35"
            className="d-inline-block align-top rounded-0"
          />

          {/* <a className="navbar-brand" href="#">Catálogo</a> */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <div>
                {user.nome && (
                  <div
                    className="nav-link compact"
                    style={{ fontSize: '0.8em' }}
                  >
                    {user.nome}
                  </div>
                )}
              </div>
            </ul>
          </div>
        </div>
      </nav>
    );
}

export default NavbarEmpty;